import utils from 'utils';
class departmentEditCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    $state,
    $stateParams,
    formvalidateApi,
    $rootScope
  ) {
    $scope.userType = $rootScope.userInfo.user.userType;
    $scope.departmentForm = {};
    $scope.isEdit = false; //是否是编辑页
    //机构树的check配置信息
    $scope.config = {
      check: {
        enable: true, //显示不显示复选框
        chkboxType: { Y: '', N: '' },
        chkStyle: 'radio',
        radioType: 'all',
      },
    };
    if ($state.current.name.indexOf('edit') > -1) {
      $scope.isEdit = true;
      httpRequest
        .get_qryDepartmentInfo($stateParams.departmentId)
        .then((res) => {
          let result = res.data.value;
          $scope.departmentForm = {
            departmentId: result.departmentId,
            departmentName: result.departmentName,
            remark: result.remark,
          };
          if ($scope.userType == 0) {
            $scope.departmentForm.orgId = result.orgId;
            $scope.orgName = result.orgName;
          }
        });
    }
    utils.loading('正在加载···');
    if ($scope.userType == 0) {
      //获取机构列表
      httpRequest.get_organization(0).then((res) => {
        $scope.orgList = res.data.value;
        utils.loaded();
        $scope.nodeCtrl($scope.orgList);
        for (var i = 0; i < $scope.orgList.length; i++) {
          if ($scope.orgList[i].orgId == $state.params.orgId) {
            $scope.queryOrgConfig.defaultSelect = [$scope.orgList[i]];
            $scope.selectedOrgList = [$scope.orgList[i]];
            $scope.queryOrgConfig.parentId = $scope.orgList[i].parentOrgId;
            $scope.departmentForm.orgId = $scope.orgList[i].orgId;
            break;
          }
        }
      });
    } else {
      utils.loaded();
    }
    // 节点的配置
    $scope.nodeCtrl = function (orgList) {
      angular.forEach(orgList, function (item) {
        item.open = true;
        item.checked = false;
      });
    };
    $scope.queryOrgConfig = {
      queryName: 'orgName',
      queryKey: 'orgId',
      queryType: 'radioTree',
      parentIdName: 'parentOrgId',
      multiple: false,
      parentId: -1,
      defaultSelect: [],
    };
    // 机构变化
    $scope.orgSelectChange = function (v) {
      $scope.queryOrgConfig.defaultSelect = v;
      $scope.departmentForm.orgId = v[0].orgId;
    };

    $scope.validateRules = {
      departmentName: [
        {
          erromsg: '部门名称不得超过20个字符',
          condition(value) {
            return value && value.length > 20;
          },
        },
      ],
      remark: [
        {
          erromsg: '部门描述不得超过50个字符',
          condition(value) {
            return value && value.length > 50;
          },
        },
      ],
    };
    // 点击取消跳转
    $scope.cancel = function () {
      $state.go('system.permission.department.list');
    };

    function validateDepartment(departmentForm) {
      if ($scope.userType == 0) {
        const orgId = departmentForm.orgId;
        if (!orgId) {
          logger.logError('请选所在择机构');
          return false;
        }
      }
      const mark = formvalidateApi.run();
      if (!mark) {
        return false;
      }
      return true;
    }
    $scope.addDepartment = function addDepartment(isContinue) {
      if (validateDepartment($scope.departmentForm)) {
        if ($scope.isEdit) {
          httpRequest
            .post_editDepartment($scope.departmentForm, '编辑部门成功')
            .then(() => {
              $state.go('system.permission.department.list');
            });
        } else {
          httpRequest
            .post_addDepartment($scope.departmentForm, '添加部门成功')
            .then(() => {
              if (isContinue) {
                $scope.departmentForm.departmentName = '';
                $scope.departmentForm.remark = '';
              } else {
                $state.go('system.permission.department.list');
              }
            });
        }
      } else {
      }
    };
  }
}
departmentEditCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  '$state',
  '$stateParams',
  'formvalidateApi',
  '$rootScope',
];
export default departmentEditCtrl;



// WEBPACK FOOTER //
// ./src/app/system/permission/department/editDepartmentCtrl.js